import React from "react";

const UserInfo = ({ username }) => {
    return (
        <div className="nav_user_info_conatiner">
            <span className="material-symbols-outlined nav_user_avatar">account_circle</span>
            <span className="nav_username">{username}</span>
        </div>
    );
};

export default UserInfo;